<template>
	<v-layout column class="salary-panel">
		<v-flex xs8>
			<v-layout row wrap align-center class="salary-items">
				<v-flex shrink>
					<span>от</span>
				</v-flex>
				<v-flex shrink>
					<v-text-field 
						solo
						type="number"
						v-model="model.start_salary"
					/>
				</v-flex>
				<v-flex shrink>
						<span>до</span>
				</v-flex>
				<v-flex shrink>
					<v-text-field 
						solo
						type="number"
						v-model="model.end_salary"
					/>
				</v-flex>
				<v-flex shrink>
					<v-select 
						class="currency-select"
						solo
						v-model="model.currency"
						:items="currencies"
						:menu-props="{ offsetY : true }"
						return-object
						item-text="short_name"
					/>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-flex v-if="display_checkbox">
			<v-checkbox 
				class="currency-checkbox"
				v-model="model.only_with_salary" 
				label="Не показывать резюме без зарплаты"
			/>
		</v-flex>
	</v-layout>
</template>

<script>
export default {
	name: "app-salary-panel",
	props: {
		model: Object,
		currencies: Array,
		display_checkbox: {
			default: true,
			type: Boolean
		}
	}
}
</script>

<style lang="less">
.salary-panel {
	.salary-items {
		.flex {
			padding-right: 8px;
		}
		.v-text-field {
			max-width: 150px;
		}
		.currency-select {
			max-width: 100px;
		}
		margin-left: -22px;
	}
	.v-input--selection-controls {
		margin-top: 0px !important;
	}
	.currency-checkbox {
		margin-left: -2px;
		.v-messages {
			display: none;
		}
	}
}
</style>